module.exports = new Promise((resolve) => {
        const script = document.createElement("script");
        script.src = "https://mais-precoce-optimize.alpha.agro.rocks/remoteEntry.js";
        script.onload = () => {
          const module = {
            get: (request) => window["pluginOptimize"].get(request),
            init: (arg) => {
              try {
                return window["pluginOptimize"].init(arg);
              } catch (e) {
                console.log("Problem loading remote pluginOptimize", e);
              }
            },
          };
          resolve(module);
        };
        script.onerror = () => {
  const module = {
    get: () => () => {},
    init: () => () => {},
  };
  resolve(module);
}
        document.head.appendChild(script);
      });